// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__VF1-Y","author":"Table_author__3AhH8","authorImage":"Table_authorImage__22Oku","unreadRow":"Table_unreadRow__2CuO_"};